export var roleType;
(function (roleType) {
    roleType["unauthorized"] = "unauthorized";
    roleType["admin"] = "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440";
    roleType["user"] = "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C";
})(roleType || (roleType = {}));
export var ROLES = [roleType.unauthorized, roleType.admin, roleType.user];
